function parseFastshopSubtotalReais(element) {
  if (!element) return 0;
  const html = element.innerHTML;
  const pricePart = (html.split(';')[1] || html.split('R$&nbsp;')[1] || '').trim();
  if (!pricePart) return 0;
  const normalized = pricePart.replace(/\s/g, '').replace(/\./g, '').replace(',', '.');
  return Number(normalized) || 0;
}

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="goCheckoutBtn--"]').forEach((btn) => {
    if (!btn.dataset.defaultHtml) {
      btn.dataset.defaultHtml = btn.innerHTML;
    }
  });
});

const openModalFastShop = (id, productIdentifier) => {
  resetSelectedCounter();
  updateProgressBar(id, 'clear')
  resetPriceBand();
  clearFastshopResume();
  const modalElement = document.getElementById(`modal--${id}`)
  if (!modalElement) return;
  modalElement.classList.add('visible-modal')
  document.body.classList.add('no-scroll');
  if (typeof updatePriceBand === 'function') {
    updatePriceBand('packModal--' + id);
  }

  const firstTab = document.querySelector(`.fastshop-container--${id} .fastshop-brand-tab`);
  if (firstTab) setActiveBrandTab(firstTab.dataset.brand, id);
  initBrandTabScrollSpy(id);

  if (productIdentifier) {
    setTimeout(() => preselectFastshopProduct(id, productIdentifier), 50);
  }
}

function preselectFastshopProduct(sectionId, productIdentifier) {
  const modal = document.getElementById(`modal--${sectionId}`);
  if (!modal) return;

  const quantityInput =
    modal.querySelector(`input.input-product-qtd--${sectionId}[data-handle="${productIdentifier}"]`) ||
    modal.querySelector(`input.input-product-qtd--${sectionId}[name="quantity_${productIdentifier}"]`);

  if (!quantityInput || Number(quantityInput.value) > 0) return;

  const productCard = quantityInput.closest('.product-item-card');
  const addButton = productCard?.querySelector('button.card-image:not([disabled])');
  if (addButton) {
    addButton.click();
  }
}
let disabledFastShopButtons = false;
function handleScrollSectionIntoView(id, sectionId) {
  const element = document.getElementById(`productSelectSection--${Number(id) + 1}--${sectionId}`);
  if (element != null) {
    element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  }else {
    const giftsSection = document.getElementById(`fastShopGifts--${sectionId}`);
    if (giftsSection != null) {
      giftsSection.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }
  } 
}
let selectedProductsAmount = 0;

function closeModal(id) {
  const itensMaxQuantity = document.getElementById(`itensMaxQuantity--${id}`);
  const currentVisibleModal = document.getElementById('modal--' + id)
  const goCheckoutBtn = document.getElementById('goCheckoutBtn--' + id);

  disabledFastShopButtons = false;
  updateProgressBar(id, 'clear')
  resetPriceBand();
  resetResumeList()
  currentVisibleModal.classList.remove('visible-modal')
  document.body.classList.remove('no-scroll');
  resetSelectedCounter();
  validateAllPack(id, itensMaxQuantity.value, 'plus')

  if (goCheckoutBtn != null) {
    goCheckoutBtn.disabled = false;
    goCheckoutBtn.classList.remove('not-clickable');
    if (!goCheckoutBtn.dataset.defaultHtml) {
      goCheckoutBtn.dataset.defaultHtml = goCheckoutBtn.innerHTML;
    }
    goCheckoutBtn.innerHTML = goCheckoutBtn.dataset.defaultHtml;
  }
}

function formatCurrency(value) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });
  return formatter.format(value / 100);
}

function updateProgressBar(sectionId , operationType) {
  const selectedItems = document.getElementById(`selectedItems--${sectionId}`);
  if(selectedItems == null) return;
  const maxCount = document.getElementById(`itensMaxQuantity--${sectionId}`);
    switch(operationType){
      case 'plus':
        selectedProductsAmount += 1
        break
      case 'minus':
        selectedProductsAmount -= 1
        break
      case 'clear':
        selectedProductsAmount = 0;
        break;
    }
  selectedItems.innerHTML = selectedProductsAmount;
  const percentage = (selectedProductsAmount / Number(maxCount.value)) * 100;
  const barFill = document.querySelector(`.progress-bar-fill--${sectionId}`);
  percentage === 100 ? setTimeout(() => { barFill.style.background = '#82C91E' }, 500) : barFill.style.background = '';
  barFill.style.width = `${percentage != 0 ? percentage : 1}%`;
}
function handleSubtotalSetter(operationType, price, quantityMultiplier, sectionId, maxGlobalQtd) {
  const unlockedGifts = document.querySelectorAll(`.fast-shop-gift--${sectionId}`);
  const currentSubtotalElement = document.querySelector('.order-subtotal--' + sectionId);
  if (currentSubtotalElement != null) {
    const html = currentSubtotalElement.innerHTML;
    const pricePart = (html.split(';')[1] || html.split('$')[1] || html.split('R$&nbsp;')[1] || '0').trim();
    const normalized = pricePart.replace(/\s/g, '').replace(/,/g, '');
    const currentSubtotal = Math.round(parseFloat(normalized) * 100) || 0;
    let newValue = 0;
    if (operationType === 'plus') {
      newValue = Number(currentSubtotal) + Number(price) * quantityMultiplier;
    } else if (currentSubtotal > 0) {
      newValue = Number(currentSubtotal) - Number(price) * quantityMultiplier;
    }
    validateGiftsUnlock(newValue, unlockedGifts, sectionId);
    currentSubtotalElement.innerHTML = formatCurrency(newValue);
    publish(PUB_SUB_EVENTS.fastshopUpdate, { source: 'fastshop', data: { sectionId } })
    verifyShowUpsellPromo(newValue);
  }
  updateProgressBar(sectionId, operationType);
  handleGlobalQuantitySetter(sectionId, maxGlobalQtd, operationType);
}
function validateGiftsUnlock(currentSubtotal, unlockedGifts, sectionId) {
  const unlockedGiftsText = document.getElementById(`unlockedGiftsText--${sectionId}`);

  unlockedGifts.forEach(gift => {
    const value = Number(gift.dataset.giftValue) * 100;
    gift.classList.toggle('locked', currentSubtotal < value);
  });
  const allGiftsUnlocked = Array.from(unlockedGifts).every(gift => !gift.classList.contains('locked'));
  if (allGiftsUnlocked) {
    unlockedGiftsText?.classList?.remove('hidden-block');
  } else {
    unlockedGiftsText?.classList?.add('hidden-block');
  }
}
async function handleGlobalQuantitySetter(sectionId, maxGlobalQtd, operationType) {
  await setTimeout(() => {
    const allProductsQtd = document.querySelectorAll('.input-product-qtd--' + sectionId);
    const qtdCircle = document.querySelector('.qtd-circle--' + sectionId);
    let globalQuantity = 0;
    if (allProductsQtd != null) {
      allProductsQtd.forEach((element) => {
        const variantId = element.name.split('_')[1];
        const quantityMultiplier = document.querySelector(`.quantity_multiplier_${variantId}`).value

        globalQuantity += Number(element.value) * Number(quantityMultiplier);
      });
    }
    if (qtdCircle != null) {
      qtdCircle.innerHTML = globalQuantity;
    }
  }, 100);
  validateAllPack(sectionId, maxGlobalQtd, operationType)
}

const FASTSHOP_SUBSCRIPTION_SELLING_PLAN_ID = 2205581569; // every 30 days

async function handleMountAndGoCheckout(sectionId, maxGlobalQtd, goCheckout = false, isSubscription = false) {
  if (validateAllPack(sectionId, maxGlobalQtd, 'plus')) {
    const cart = document.querySelector('cart-drawer');
    const productArray = { items: [] };
    const allProductsQtd = document.querySelectorAll('.input-product-qtd--' + sectionId);
    if (allProductsQtd != null && allProductsQtd.length) {
      allProductsQtd.forEach((element) => {
        if (element.value > 0) {
          const variantId = element.name.split('_')[1];
          const quantityMultiplier = document.querySelector(`.quantity_multiplier_${variantId}`).value
          const currentQuantity = element.value * Number(quantityMultiplier);
          const item = { id: variantId, quantity: currentQuantity };
          if (isSubscription) {
            item.selling_plan = FASTSHOP_SUBSCRIPTION_SELLING_PLAN_ID;
          }
          productArray.items.push(item);
        }
      });
    }

    const goCheckoutBtn = document.getElementById('goCheckoutBtn--' + sectionId);

    if (goCheckoutBtn != null) {
      goCheckoutBtn.disabled = true;
      goCheckoutBtn.classList.add('not-clickable');
      setButtonLoadSpinner(goCheckoutBtn, 10000, 16, 'dots');
    }
    if(goCheckout){
      await clearCart();
      await addToCartPack(productArray, sectionId);
    }else {
      let cartBody;
      cartBody = await addCartItemsInBulk(productArray.items);

      closeModal(sectionId);
      if (cart && typeof cart.open === 'function') {
        cart.open();
      } else if (typeof openCart === 'function') {
        openCart();
      }
      updateCartDrawer(cartBody);
    }
  } else {
    const packContainer = document.querySelector('.campaign-packs')
    scrollToElementWithOffset(packContainer, -120);
  }
}

async function handleSelectorMountAndGoCheckout(sectionId, goCheckout = false, isSubscription = false) {
  const modal = document.getElementById('modal--' + sectionId);
  const cartInputs = modal != null ? modal.querySelectorAll('.selector-cart-input') : [];
  const productArray = { items: [] };

  cartInputs.forEach((element) => {
    const variantId = element.name.split('_')[1];
    if (!variantId) return;
    const quantity = Number(element.value) || 1;
    const existingItem = productArray.items.find((item) => item.id === variantId);
    if (existingItem) {
      existingItem.quantity += quantity;
      return;
    }
    const item = { id: variantId, quantity };
    if (isSubscription) {
      item.selling_plan = FASTSHOP_SUBSCRIPTION_SELLING_PLAN_ID;
    }
    productArray.items.push(item);
  });

  if (!productArray.items.length) return;

  const goCheckoutBtn = document.getElementById('goCheckoutBtn--' + sectionId);

  if (goCheckoutBtn != null) {
    goCheckoutBtn.disabled = true;
    goCheckoutBtn.classList.add('not-clickable');
    setButtonLoadSpinner(goCheckoutBtn, 10000, 16, 'dots');
  }

  if (goCheckout) {
    await clearCart();
    await addToCartPack(productArray);
  } else {
    const cartBody = await addCartItemsInBulk(productArray.items);
    closeModal(sectionId);
    const cart = document.querySelector('cart-drawer');
    if (cart != null && typeof cart.open === 'function') {
      cart.open();
    } else {
      openCart();
    }
    updateCartDrawer(cartBody);
  }
}

async function addToCartPack(items) {
  const url = '/cart/add.js';

  await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(items),
  }).then(response => {
    setTimeout(() => window.location.href = '/checkout', 4000)
  }).catch((error) => {
    if (goCheckoutBtn != null) {
      goCheckoutBtn.disabled = false;
      goCheckoutBtn.classList.remove('not-clickable');
      goCheckoutBtn.innerHTML = "Ocorreu um erro ao atualizar o carrinho";
    }
    console.error('Error:', error);
  });
}
async function addCartItemsInBulk(items) {
  const cart = document.querySelector('cart-drawer');
  let sections = [];
  try {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      sections = cart.getSectionsToRender().map(section => section.id);
    };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items,
        sections,
        sections_url: window.location.pathname
      })
    });

    const result = await response.json();
    return { ...result, items }
  } catch (error) {
    console.error('Erro ao sincronizar item do carrinho:', error);
  }
}


function validateProductBlock(sectionId, maxQtd, operationType) {
  const quantityInputs = document.querySelectorAll(`#quantity--${sectionId}`)
  const quantityMultiplier = document.getElementById(`quantity_multiplier--${sectionId}`)
  const blockImages = document.querySelectorAll(`.product-item-card--${sectionId}`)
  let blockCount = 0;
  if (quantityInputs != null && quantityInputs.length > 0 && !disabledFastShopButtons) {
    quantityInputs.forEach(element => {
      blockCount += Number(element.value);
    })
  }
  if (operationType == 'plus' && blockCount >= maxQtd - 1) {
    asyncValidateProductBlock(blockImages);
  } else {
    blockImages.forEach(element => element.classList.remove('grayscale-disabled'));
  }
  if(disabledFastShopButtons)return
  return blockCount < maxQtd;
}

function asyncValidateProductBlock(blockImages) {
  setTimeout(() => {
    blockImages.forEach(element => {
      const innerDivInput = element.querySelector('.card-info .quantity-box input')
      if (innerDivInput && innerDivInput.value > 0) {
        element.classList.remove('grayscale-disabled')
      } else {
        element.classList.add('grayscale-disabled')
      }
    });
  }, 100);
}

function validateAllPack(sectionId, maxQtdGlobal, operationType) {
  const globalQuantity = document.querySelector('.qtd-circle--' + sectionId);
  const globalMaxQuantity = maxQtdGlobal
  const buttonDisabled = document.querySelector('.buttonCheckout--' + sectionId);
  if ((globalQuantity.innerHTML >= globalMaxQuantity - 1 && operationType == 'plus') || (globalMaxQuantity >= 999 && globalQuantity.innerHTML >= 0  && operationType == 'plus')) {
    buttonDisabled.classList.remove('disabledForced')
  } else if (globalQuantity.innerHTML <= globalMaxQuantity) {
    buttonDisabled.classList.add('disabledForced')
  }

  return globalMaxQuantity >= 999 || globalQuantity.innerHTML >= globalMaxQuantity;
}

function resetSelectedCounter() {
  const productCards = document.querySelectorAll('.product-item-card');
  const subtotals = document.querySelectorAll('#order-subtotal');
  const qtdCircles = document.querySelectorAll('.qtd-circle');
  if (productCards != null && subtotals != null && qtdCircles != null) {
    subtotals.forEach(subtotal => subtotal.innerHTML = 'R$&nbsp;0,00');
    qtdCircles.forEach(qtdCircle => qtdCircle.innerHTML = 0);
    productCards.forEach(card => {
      card.classList.remove('grayscale-disabled');
      card.classList.remove('global-grayscale-disabled');
      card.dispatchEvent(new CustomEvent('reset-count'));
    });
  }
}

function scrollToElementWithOffset(element, offset) {

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
  const offsetPosition = elementPosition + offset;

  setTimeout(() => {
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }, 400);
}

function resetResumeList() {
  const fastShopResumeListElements = document.querySelectorAll(`.fastshop-resume-list`);
  fastShopResumeListElements.forEach(element => element.innerHTML = '');
  const selectedProductsPreviewElements = document.querySelectorAll(`.fastshop-selected-products-preview`);
  selectedProductsPreviewElements.forEach(element => element.innerHTML = '');
}

function toggleResumeVisibility(id) {
  const clearFastShopItensButton = document.getElementById('clearFastShopItensButton')
  const resumeSection = document.querySelector(`.fastshop-resume-section--${id}`);
  const buttonsResumeSpan = document.querySelectorAll(`.button-toggle--${id} span`);
  const fastShopResumeListElement = document.getElementById(`fastshop-resume--${id}`);
  const seeMoreChevron =  document.getElementById(`see-more-chevron--${id}`);
  if(seeMoreChevron != null){
    seeMoreChevron.classList.toggle('rotate-180');
  }
  if (fastShopResumeListElement != null && buttonsResumeSpan != null) {
    fastShopResumeListElement.classList.toggle('hidden')
    buttonsResumeSpan.forEach(element => element.classList.toggle('hidden'))
    resumeSection.classList.toggle('items-start')
    clearFastShopItensButton.toggle('hidden')
  }
  calculateAndSetPaddingBottom(id)
}

function mountFastshopResume(id) {
  setTimeout(() => {
    const resumeSection = document.querySelector(`.fastshop-resume-section--${id}`);
    const productList = fastshopResume.getCurrentProductList();
    const fastShopResumeListElement = document.getElementById(`fastshop-resume--${id}`)
    fastShopResumeListElement.innerHTML = '';
    if (productList != null && productList.length != 0) {
      resumeSection.classList.remove('hidden');
        // Group products by id and count quantities
      const productMap = new Map();
      productList.forEach(item => {
        const key = item.id || item.variantId || item.title; // Use a unique identifier
        if (!productMap.has(key)) {
          productMap.set(key, { ...item, quantity: 1 });
        } else {
          productMap.get(key).quantity += 1;
        }
      });

      // Render grouped products
      productMap.forEach(item => {
        const priceFormated = formatCurrency(item.price);
        fastShopResumeListElement.innerHTML += `
        <li class="fastshop-product-item">
          <span>${item.title}</span>
          <span data-fullprice='${item.price}' id="fastShopListItemPrice">${item.quantity}x ${priceFormated}</span>
        </li>
        `
      });
    } else if (productList.length === 0) {
      resumeSection.classList.add('hidden');
    }
  }, 500)
}

function setProductImage(id) {
  const lastProductOnList = fastshopResume.getCurrentProductList().at(-1);
  const iconProduct = document.getElementById(`icon-product--${id}`)
  if (iconProduct != null && lastProductOnList != null) {
    iconProduct.src = lastProductOnList.images[0]
  }
}

function mountSelectedProductsPreview(id) {
  const previewElement = document.getElementById(`fastShopSelectedProductsPreview--${id}`);
  if (previewElement == null) return;
  const productList = fastshopResume.getCurrentProductList();
  const productMap = new Map();
  productList.forEach(product => {
    if (!productMap.has(product.id)) {
      productMap.set(product.id, { ...product, quantity: 1 });
    } else {
      productMap.get(product.id).quantity += 1;
    }
  });
  previewElement.innerHTML = Array.from(productMap.values())
    .map(product => {
      const imgSrc = product.images?.[0] || '';
      if (!imgSrc) return '';
      return '<div class="fastshop-selected-product-preview-item">'
        + '<img loading="lazy" src="' + imgSrc + '" alt="' + (product.title || '') + '">'
        + '<span class="fastshop-selected-product-preview-quantity">' + product.quantity + '</span>'
        + '</div>';
    })
    .join('');
}

function handleFastshopResumeVisuals(id) {
  mountFastshopResume(id)
  setProductImage(id)
  mountSelectedProductsPreview(id)
}

function setActiveBrandTab(brand, fastshopId) {
  const container = document.querySelector(`.fastshop-container--${fastshopId}`);
  if (container == null) return;
  container.querySelectorAll('.fastshop-brand-tab').forEach(tab => {
    tab.classList.toggle('fastshop-brand-tab--active', tab.dataset.brand === brand);
  });
}

function scrollFastshopToBrand(brand, fastshopId) {
  const container = document.querySelector(`.fastshop-container--${fastshopId}`);
  const productContainer = document.querySelector(`.product-container--${fastshopId}`);
  if (container == null || productContainer == null) return;
  setActiveBrandTab(brand, fastshopId);
  const target = container.querySelector(`.product-section-block[data-brand="${brand}"]`);
  if (target == null) return;
  const headerEl = container.querySelector('.modal-header');
  const headerOffset = headerEl ? headerEl.offsetHeight : 0;
  const targetOffsetFromContainer = target.getBoundingClientRect().top - productContainer.getBoundingClientRect().top;
  productContainer.scrollTo({
    top: productContainer.scrollTop + targetOffsetFromContainer - headerOffset - 16,
    behavior: 'smooth'
  });
}

function initBrandTabScrollSpy(fastshopId) {
  const container = document.querySelector(`.fastshop-container--${fastshopId}`);
  const productContainer = document.querySelector(`.product-container--${fastshopId}`);
  if (container == null || productContainer == null) return;
  if (productContainer.dataset.brandScrollSpyBound) return;
  const tabs = container.querySelectorAll('.fastshop-brand-tab');
  if (tabs.length < 2) return;
  productContainer.dataset.brandScrollSpyBound = 'true';

  const headerEl = container.querySelector('.modal-header');
  const headerOffset = headerEl ? headerEl.offsetHeight : 0;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setActiveBrandTab(entry.target.dataset.brand, fastshopId);
      }
    });
  }, {
    root: productContainer,
    rootMargin: `-${headerOffset + 1}px 0px -70% 0px`,
    threshold: 0
  });

  container.querySelectorAll('.product-section-block[data-brand]').forEach(section => {
    if (section.dataset.brand && section.dataset.brand !== 'outros') {
      observer.observe(section);
    }
  });
}

function calculateAndSetPaddingBottom(id) {
  const productContainer = document.querySelector(`.product-container--${id}`);
  const fixedBottomBar = document.querySelector(`.fixed-bottom-bar--${id}`)
  const paddingOffset = fixedBottomBar.offsetHeight + 15
  if (productContainer != null && fixedBottomBar != null) {
    productContainer.style.paddingBottom = `${paddingOffset}px`;
  }
}

function goToUpsell() {
  const upsellFastShop = document.getElementById('upsell-binded');
  upsellFastShop.classList.remove('hidden');
  scrollToElementWithOffset(upsellFastShop, -50);
}

function verifyShowUpsellPromo(moneyInCents) {
  const upsellFastShop = document.querySelector('.fastshop-upsell-card');
  if (moneyInCents >= 27000 && upsellFastShop != null) {
    upsellFastShop.classList.remove('hidden');
  }
}

function clearFastShopItens(id){
  updateProgressBar(id, 'clear')
  resetPriceBand();
  resetResumeList();
  clearFastshopResume();
  document.querySelectorAll('#order-total').forEach(el => el.textContent = 'R$\u00A00,00');
  document.querySelectorAll('#order-total-discount').forEach(el => el.textContent = 'R$\u00A00,00');
  resetSelectedCounter();
  document.querySelectorAll('.order-discount-pix').forEach((orderDiscountElement) => {
    orderDiscountElement.classList.add('hidden-block');
  });
}

function validateAllProductSelections(containerId, maxQuantity){
  const containerElement = document.querySelector(`.product-container--${containerId}`);
  const productSelectionSections = containerElement?.querySelectorAll('.product-section-block');
  let totalCount = 0;
  productSelectionSections?.forEach(section => {
    const sectionId = section.querySelector('.product-section-id').value
    const quantityInputs = document.querySelectorAll(`#quantity--${sectionId}`)
    if (quantityInputs != null && quantityInputs.length > 0) {
      quantityInputs.forEach(element => {
        totalCount += Number(element.value);
      })
    }
  });
  if(totalCount >= maxQuantity){
    disabledFastShopButtons = true;
    productSelectionSections?.forEach(section => {
      const sectionId = section.querySelector('.product-section-id').value
      const blockImages = document.querySelectorAll(`.product-item-card--${sectionId}`)
      blockImages.forEach(element => {
        const elementAlpineData = Alpine.$data(element);
        if(elementAlpineData.count > 0) {
          return;
        }
        element.classList.add('global-grayscale-disabled')
      });
    });
  }
  else{
    disabledFastShopButtons = false;
    productSelectionSections?.forEach(section => {
      const sectionId = section.querySelector('.product-section-id').value
      const blockImages = document.querySelectorAll(`.product-item-card--${sectionId}`)
      blockImages.forEach(element => {
        element.classList.remove('global-grayscale-disabled')
      });
    });
  }
  advanceBrandTabIfCurrentIsComplete(containerElement, containerId);
}

function advanceBrandTabIfCurrentIsComplete(containerElement, containerId) {
  if (containerElement == null) return;
  const tabs = Array.from(containerElement.querySelectorAll('.fastshop-brand-tab'));
  if (tabs.length < 2) return;
  const activeIndex = tabs.findIndex(tab => tab.classList.contains('fastshop-brand-tab--active'));
  if (activeIndex === -1 || activeIndex >= tabs.length - 1) return;
  const activeBrand = tabs[activeIndex].dataset.brand;
  const brandSections = Array.from(containerElement.querySelectorAll(`.product-section-block[data-brand="${activeBrand}"]`));
  if (brandSections.length === 0) return;
  const allSectionsComplete = brandSections.every(section => {
    const maxQuantity = Number(section.querySelector('.product-section-max-quantity')?.value);
    if (!maxQuantity || maxQuantity >= 999) return false;
    const sectionId = section.querySelector('.product-section-id')?.value;
    const quantityInputs = document.querySelectorAll(`#quantity--${sectionId}`);
    let sectionCount = 0;
    quantityInputs.forEach(input => {
      sectionCount += Number(input.value) || 0;
    });
    return sectionCount >= maxQuantity;
  });
  if (allSectionsComplete) {
    scrollFastshopToBrand(tabs[activeIndex + 1].dataset.brand, containerId);
  }
}